import React, { useState } from 'react'
import { RouteProp, useRoute } from '@react-navigation/native'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import { NotesScreen, EditNote } from '@screens'

export type NotesStackParamList = {
  NotesList: {
    profileId?: string
  }
  EditNote:
    | {
        noteId?: string
        contactId?: string
        isGhost?: boolean
      }
    | undefined
}

const Stack = createNativeStackNavigator<NotesStackParamList>()

// The editor can stay under another screen (the profile opened from the note)
// and be opened again from there, on another note or on a new one. Each
// opening gets a fresh editor (the one that closes saves what was left in it):
// kept as it was, it showed the previous note's text in the new one.
const EditNoteScreen: React.FC = () => {
  const { params } = useRoute<RouteProp<NotesStackParamList, 'EditNote'>>()
  // Navigating to the editor again hands it new params, even with equal values.
  const [opening, setOpening] = useState({ params, count: 0 })
  if (opening.params !== params) {
    setOpening({ params, count: opening.count + 1 })
  }

  return <EditNote key={opening.count} />
}

const NotesStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="NotesList" component={NotesScreen} />
      <Stack.Screen name="EditNote" component={EditNoteScreen} />
    </Stack.Navigator>
  )
}

export default NotesStackNavigator
